/* PDP-11 (17.09.2026) — сателлит шторки деталей, редакция 3.
   amore-pdp.js (зона карточка) не переписывается: здесь дополняются методы
   того же класса <amore-product>.
   1. Дюймы — с точностью до четверти (25½), вилки через тире.
   2. Таблица всех размеров пересчитывается при смене единиц.
   3. Подпись чертежа: «Where we measure · XS».
   4. Единицы по умолчанию — из data-amore-default-unit (US и GB — дюймы).
   5. Ссылка «Materials & care» в колонке покупки открывает Details.
   PDP-14: касание строки делает её активной, наведение закрывает рамками колонку (механика Toteme). */
(function () {
  const AmoreProduct = customElements.get('amore-product');
  if (!AmoreProduct || AmoreProduct.prototype.__amorePdp11) return;
  AmoreProduct.prototype.__amorePdp11 = true;

  const QUARTERS = ['', '¼', '½', '¾'];

  function inches(cm) {
    const quarters = Math.round((cm / 2.54) * 4);
    const whole = Math.floor(quarters / 4);
    const rest = quarters % 4;
    if (!whole) return rest ? QUARTERS[rest] : '0';
    return String(whole) + QUARTERS[rest];
  }

  AmoreProduct.prototype.convertMeasure = function (raw) {
    if (raw === '' || raw === undefined || raw === null) return null;
    const bounds = String(raw).split('-').map((part) => part.trim());
    const numbers = bounds.map((bound) => (bound === '' ? NaN : Number(bound)));
    if (numbers.some((number) => !isFinite(number))) return null;
    return numbers.map((number) => (this.unit === 'cm' ? String(number) : inches(number))).join('–');
  };

  const baseUpdate = AmoreProduct.prototype.updateMeasurementState;
  AmoreProduct.prototype.updateMeasurementState = function (size) {
    baseUpdate.call(this, size);
    renderSheet(this, size);
  };

  function renderSheet(product, size) {
    product.querySelectorAll('[data-amore-cm]').forEach((cell) => {
      const value = product.convertMeasure(cell.dataset.amoreCm);
      cell.textContent = value === null ? '' : value;
      cell.classList.toggle('is-narrow', value !== null && value.length > 4);
    });
    product.querySelectorAll('[data-amore-unit-word]').forEach((node) => {
      node.textContent = product.unit === 'in' ? 'inches' : 'centimeters';
    });
    const hasRow = size && product.querySelector(`[data-amore-pdp-sheet-size="${CSS.escape(size)}"]`);
    product.querySelectorAll('.amore-mdg > .amore-pdp-details__label').forEach((label) => {
      label.textContent = hasRow ? `Where we measure · ${size}` : 'Where we measure';
    });
  }

  function bindRows(product) {
    product.querySelectorAll('.amore-pdp-11-table tbody').forEach((body) => {
      body.addEventListener('click', (event) => {
        const row = event.target.closest('tr');
        if (!row) return;
        const on = !row.classList.contains('is-row-active');
        body.querySelectorAll('tr.is-row-active').forEach((other) => other.classList.remove('is-row-active'));
        row.classList.toggle('is-row-active', on);
      });
    });
    product.querySelectorAll('.amore-pdp-11-table').forEach((table) => {
      const clear = () => table.querySelectorAll('.is-col-hover').forEach((cell) => cell.classList.remove('is-col-hover'));
      table.addEventListener('mouseover', (event) => {
        const cell = event.target.closest('[data-amore-pdp-conv-col]');
        clear();
        if (!cell) return;
        table.querySelectorAll(`[data-amore-pdp-conv-col="${cell.dataset.amorePdpConvCol}"]`).forEach((match) => match.classList.add('is-col-hover'));
      });
      table.addEventListener('mouseleave', clear);
    });
  }

  function init(product) {
    bindRows(product);
    product.querySelectorAll('[data-amore-pdp-details-open="care"]').forEach((link) => {
      link.dataset.amorePdpDetailsOpen = 'details';
    });
    const drawer = product.querySelector('[data-amore-pdp-details]');
    const unit = drawer && drawer.dataset.amoreDefaultUnit === 'in' ? 'in' : 'cm';
    product.unit = unit;
    product.querySelectorAll('[data-amore-pdp-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.amorePdpUnit === unit));
    });
    const selected = product.variantById ? product.variantById(product.dataset.selectedVariantId) : null;
    product.updateMeasurementState(selected ? selected.size : '');
  }

  document.querySelectorAll('amore-product').forEach(init);
})();

/* PDP-15 (17.09.2026) — полноэкранный просмотр фото по механике Toteme (владелец).
   Toteme (замер toteme.com, 1470×835): фото во всю ширину экрана (1470×2058),
   листаются вертикально без привязки, миниатюры 48px слева с шагом 24px,
   текущая — непрозрачная. Картинка по размеру (CSS в amore-frame-14.css, PDP-15).
   Базовый скрипт карточки считал текущий кадр как scrollTop / высота экрана —
   для кадров выше экрана это неверно. Здесь: текущий кадр — тот, что пересекает
   середину экрана; клик по миниатюре листает к верху кадра. Только ≥900px —
   ниже раскладка просмотра прежняя. */
(function () {
  function frames(d) { return Array.prototype.slice.call(d.querySelectorAll('.amore-pdp-zoom__frame')); }
  function thumbs(d) { return Array.prototype.slice.call(d.querySelectorAll('[data-amore-pdp-zoom-thumb]')); }
  function wide() { return window.matchMedia('(min-width: 900px)').matches; }
  function mark(d) {
    var sc = d.querySelector('.amore-pdp-zoom__scroll');
    if (!sc) return;
    var line = sc.scrollTop + sc.clientHeight / 2, idx = 0;
    frames(d).forEach(function (f, i) { if (f.offsetTop <= line) idx = i; });
    thumbs(d).forEach(function (b, i) { b.classList.toggle('is-current', i === idx); });
    var cur = thumbs(d)[idx], rail = d.querySelector('.amore-pdp-zoom__rail');
    if (cur && rail) rail.scrollTo({ top: cur.offsetTop - rail.clientHeight / 2 + cur.offsetHeight / 2, behavior: 'smooth' });
  }
  function bind(d) {
    if (d.__amoreZoom15) return;
    d.__amoreZoom15 = true;
    var sc = d.querySelector('.amore-pdp-zoom__scroll');
    if (!sc) return;
    sc.addEventListener('scroll', function () {
      if (!wide()) return;
      requestAnimationFrame(function () { mark(d); });
    }, { passive: true });
    d.addEventListener('click', function (e) {
      if (!wide()) return;
      var b = e.target.closest('[data-amore-pdp-zoom-thumb]');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var f = frames(d)[Number(b.getAttribute('data-amore-pdp-zoom-thumb'))];
      if (f) sc.scrollTo({ top: f.offsetTop, behavior: 'smooth' });
    }, true);
    new MutationObserver(function () {
      if (d.open && wide()) setTimeout(function () { mark(d); }, 60);
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  function init() { document.querySelectorAll('.amore-pdp-zoom').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
